/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import LocationMapContainer from './map.jsx';
import { getTrackingTableColumns } from './trackingTable';
import { getCountDownTimer } from './utils';
import ActionButton from '../../common/ActionButton';
import * as api from '../../../epics/api';
import history from '../../../history';
import {flattenBookingsToJobs} from "../../../api/DataHandlers";

class FreelancerLocationMapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: [],
            fetching: true,
        };
        this.getBooking(this.props.match.params.bookingId);
    }

    getTrackingTableColumns = () =>
        getTrackingTableColumns(this, this.props.user);

    getBooking(bookingId) {
        const self = this;
        self.setState({ fetching: true });
        const response = api.executeHttpRequest(
            `jobs/?booking_id=${bookingId}`,
        );
        response.then(res => {
            const job = flattenBookingsToJobs(res.data).content[0]
            if (job) {
                self.setState({
                    fetching: false,
                    job: [job],
                });
            } else {
                self.setState({
                    fetching: false,
                });
            }
        });
    }

    render() {
        return (
            <div className="table-container">
                {this.props.user.isAgent ? (
                    <div className="table-filter-container">
                        <div className="table-action-bar">
                            <div className="grouped-buttons">
                                <ActionButton
                                    tooltip="List view"
                                    iconClass="icon-view-list"
                                    onAction={() =>
                                        history.push(
                                            '/operations/locationtracking/',
                                        )
                                    }
                                />
                                <ActionButton
                                    active={true}
                                    tooltip="Map view"
                                    iconClass="icon-map-pin-1"
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
                <ReactTable
                    pageSize={0}
                    data={this.state.job}
                    pages={0}
                    columns={this.getTrackingTableColumns()}
                    showPaginationBottom={false}
                    className="table-content tracking-table"
                    loading={this.state.fetching}
                    showPageSizeOptions={false}
                    manual={true}
                />
                {this.state.job.length != 0 ? (
                    <LocationMapContainer
                        job={this.state.job[0]}
                        showDirections={true}
                        loadTrackingMapData={this.props.loadTrackingMapData}
                        countDownTimer={getCountDownTimer}
                        isAgent={this.props.user.isAgent}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    if (state.tracking) {
        const newState = {
            user: state.user,
        };
        return newState;
    }
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps)(FreelancerLocationMapContainer);
